import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommandeStatut } from 'src/api/models/commande-statut';

@Component({
  selector: 'app-statut-commande',
  templateUrl: './statut-commande.component.html',
  styleUrls: ['./statut-commande.component.css']
})
export class StatutCommandeComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetStatutCommande(s: CommandeStatut) {
    if (s === undefined) {
      return '';
    } else {
      return this.translateService.instant('Stock.Commandes.Statuts.' + CommandeStatut[s]);
    }
  } 
}
